import {Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, ViewChild} from '@angular/core';
import {DISTRIBUTION_LINKS} from '../../../models/distribution-links';
import {DeviceOs} from '../../../models/device-os';
import { NgxStarsModule } from 'ngx-stars';
import { NgFor, NgIf } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterLink } from '@angular/router';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: true,
    imports: [NgxJsonLdModule, RouterLink, FontAwesomeModule, NgFor, NgxStarsModule, NgIf],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeComponent {
  public distributionLinks = DISTRIBUTION_LINKS;
  public deviceOss = DeviceOs;
  public reviews: { truncated: boolean, truncatedBody: string, body: string, author: string, showFull: boolean, stars: number }[] = [
    {
      truncated: true,
      truncatedBody: 'De app \'Bruiloft in je Broekzak\' is een superfijne en -handige must have tijdens je bruiloft! Lappen tekst op de uitnodiging zijn niet meer nodig&hellip;',
      body: 'De app \'Bruiloft in je Broekzak\' is een superfijne en -handige must have tijdens je bruiloft! Lappen tekst op de uitnodiging zijn niet meer nodig, want aanvullende info (zoals info van de ceremoniemeesters, dresscode, cadeauwensen) kun je gemakkelijk in de app plaatsen. Ook de functie \'RSVP\' is superhandig, waarin gasten kunnen aangeven of ze erbij zijn. Dat scheelt weer een heleboel mails in de inbox van de ceremoniemeesters ;-) Daarnaast is het tof dat je de app persoonlijk kunt maken met eigen foto\'s en achtergronden, en dat zelfs de gasten foto\'s kunnen plaatsen in het album.',
      author: 'Tom &amp; Laurine',
      showFull: false,
      stars: 5
    },
    {
      truncated: true,
      truncatedBody: 'Hele leuke gebruikersvriendelijke app. Erg creatief en werkt goed. Hele leuke manier om je foto\'s met andere gasten te delen en alvast contact te leggen&hellip;',
      body: 'Hele leuke gebruikersvriendelijke app. Erg creatief en werkt goed. Hele leuke manier om je foto\'s met andere gasten te delen en alvast contact te leggen voor de bruiloft. (bijv. als je met iemand mee wilt rijden) Daarnaast alle nodige gegevens (waar je wanneer moet zijn) makkelijk bij de hand.',
      author: 'Mathijs (gast)',
      showFull: false,
      stars: 5
    },
    {
      truncated: true,
      truncatedBody: 'Als gast vond ik de app heel fijn om te gebruiken. Wat ik heel fijn vond was dat de route gewoon in de app stond! We moesten tijdens de bruiloft&hellip;',
      body: 'Als gast vond ik de app heel fijn om te gebruiken. Wat ik heel fijn vond was dat de route gewoon in de app stond! We moesten tijdens de bruiloft van 1 locatie naar een andere rijden, het was heel fijn dat dat gewoon in de app stond. De cadeaulijst werkte heel prettig. Ik zag wel dat het bruidspaar en wat directe familieleden al wat foto’s stuurden aan het begin van de dag.<br />' +
        'Op de cadeaulijst na hebben we vooral tijdens en na het feest genoten van de app. Vooral van de foto’s heb ik kunnen genieten, meestal heb je alleen je eigen foto’s en moet ook het bruidspaar lang wachten op de officiële foto’s.',
      author: 'Anonieme gast',
      showFull: false,
      stars: 5
    },
    {
      truncated: true,
      truncatedBody: 'Wij raden dit iedereen aan, omdat je hier veel voorpret aan kan beleven en dat het interactief is voor je gasten!',
      body: 'Wij zouden gaan trouwen in Frankrijk. Alles was geregeld, vormgeving voor de kaart was klaar en alles was al gepland. Totdat corona kwam&hellip; We hebben getwijfeld: Wat zullen we doen? Maar één ding stond vast, wij willen gaan trouwen hoe dan ook, want onze liefde die is niet veranderd. Wat wel ons probleem was, hoe gaan we alles in 2,5 maand regelen? Onze bruiloft moest namelijk van Frankrijk naar Nederland. Cynthia zag de bekendmaking van de app waarbij voor ons duidelijk werd dat dit een manier zou kunnen zijn hoe we het snelst konden communiceren met onze gasten en met name voor de ceremoniemeesters. Na het downloaden van de app hebben we alles helemaal kunnen aanpassen in onze eigen stijl, hebben we onze cadeaulijst toe kunnen voegen, chatfunctie, onze dresscode en hadden de ceremoniemeesters hun geheime gedeelte. Daar werden we echt heel blij van. De tijd was voor ons te kort om een aangepaste kaart te sturen, maar als vervanging daarvoor hadden wij dus deze app!<br /><br />Uiteindelijk hebben wij hierin onze gasten verdeeld in dag- en online gasten (dit omdat onze bruiloft ge-livestreamd werd). Door de app hebben wij dus ook een win-actie voor onze online gasten gemaakt waarin de gasten met de leukste foto een driegangenmenu bij ons thuis konden winnen. Ook hier is massaal op gereageerd waardoor wij ook hebben gemerkt dat de interactie erg goed was ook nog op de dag zelf.<br /><br />Dus al met al is deze app een oplossing geweest om in deze coronatijd waarin wij, onze ceremoniemeesters, onze dag- en online gasten makkelijker hebben kunnen communiceren. Wij raden dit iedereen aan, omdat je hier veel voorpret aan kan beleven en dat het interactief is voor je gasten!',
      author: 'Cynthia &amp; Gideon',
      showFull: false,
      stars: 5
    },
    {
      truncated: true,
      truncatedBody: 'We kwamen de app Bruiloft in je Broekzak tegen op een trouwbeurs en waren meteen enthousiast. We twijfelden heel even vanwege de kosten (trouwen is zo duur!), maar&hellip;',
      body: 'We kwamen de app Bruiloft in je Broekzak tegen op een trouwbeurs en waren meteen enthousiast. We twijfelden heel even vanwege de kosten (trouwen is zo duur!), maar we hebben er nooit een seconde spijt van gehad. De communicatie vanuit ons naar de gasten liep goed, we hoefden niet steeds iedereen te mailen/appen. Waar we tegen dingen aan liepen was het contact met de app-bouwers praktisch, en positief en er bleek meer mogelijk dan we dachten. Verschillende talen waren super prettig voor ons internationale gezelschap. Ook de cadeau-lijst en de \'geheime afdeling\' zijn volop gebruikt. En toen we de ochtend na de bruiloft wakker werden, stond plotseling de foto pagina vol met foto\'s van onze gasten; zo leuk! Een echte aanrader en must-use voor een moderne bruiloft van deze tijd!',
      author: 'Carolien',
      showFull: false,
      stars: 5
    }
  ];
  public reviewIndex = 0;

  @ViewChild('swiper', {static: true})
  public swiperRef: ElementRef;

  constructor() {
    this.randomizeReviews();
  }

  public showFullReview(review: { truncated: boolean, truncatedBody: string, body: string, author: string, showFull: boolean, stars: number }): void {
    const oldShowFull = review.showFull;
    setTimeout(() => {
      review.showFull = !oldShowFull;
    }, 1);
  }

  public randomizeReviews(): void {
    this.reviews = this.reviews.sort((_a, _b) => {
      return .5 - Math.random();
    });
  }

  public slideLeft(): void {
    this.resetFull();
    this.swiperRef.nativeElement.swiper.slidePrev();
  }

  public slideRight(): void {
    this.resetFull();
    this.swiperRef.nativeElement.swiper.slideNext();
  }

  public resetFull(): void {
    this.reviews.forEach(x => x.showFull = false);
  }
}
